export default __webpack_public_path__ + "assets/images/864f41150cd15618b01d8fe83517cd6c.png";